import React from 'react';
import { Box } from '@mui/material';
import ProfileHeader from './components/ProfileHeader';
import ProfileForm from './components/ProfileForm';


const UserProfileForm: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f8f9fa',
        padding: { xs: 1, sm: 2, md: 3 },
        // padding: { xs: 2, sm: 3, md: 4 },
      }}
    >
        <ProfileHeader />
        <ProfileForm />
      
    </Box>
  );
};

export default UserProfileForm;